export const queryKeys = {
    CURRENCY_LIST_BASIC: 'CURRENCY_LIST_BASIC'
}